<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader v-show="params.back_button_visible !== '0'" label="Подписка" />

        <q-tab-panels v-model="tab" class="sot-page fit" animated v-if="!loading" style="padding-top: 60px">
            <q-tab-panel name="info">
                <div v-if="subscription" class="column q-gutter-y-md" style="padding-bottom: 20px">
                    <div class="text-weight-bold">{{ subscription.title }}</div>
                    <div>{{ subscription.description }}</div>
                    <div v-if="subsBought">
                        <div class="text-weight-bold">Подписка оформлена</div>
                        <div>Дата окончания подписки: {{ formatDateShort(subsBought.valid_until_date) }}</div>
                    </div>
                    <div class="column q-gutter-y-md" v-if="!subsBought">
                        <div v-for="(p, i) in prices" :key="i" class="column q-gutter-md">
                            <div class="row text-weight-bold">
                                <div>
                                    Тариф <span v-show="+p.duration_months > 0">{{ formatMonths(p.duration_months) }}</span> <span v-show="+p.duration_days > 0">{{ formatDays(p.duration_days) }}</span>
                                </div>
                                <q-space />
                                <div>{{ p.price_personal }} ₽</div>
                            </div>
                            <DefaultButton :label="`Купить за ${p.price_personal} ₽`" @click="buySubscription(p)" />
                        </div>
                    </div>
                </div>
            </q-tab-panel>
            <q-tab-panel name="tasks">
                <div v-if="subscription" class="column q-gutter-y-md" style="padding-bottom: 20px">
                    <div class="text-weight-bold">Состав подписки</div>
                    <div>Курсы</div>
                    <div v-for="(course, i) in courses" :key="i">
                        <SotButton :label="course.title" :params="{ author: course.author }" @click="courseClick(course)" class="full-width" />
                    </div>
                </div>
            </q-tab-panel>
        </q-tab-panels>
        <q-space />
        <div v-if="!loading">
            <q-tabs v-model="tab" align="justify" no-caps dense>
                <q-tab name="info" icon="home" label="Описание" style="width: 90px;" />
                <q-tab name="tasks" icon="list" label="Состав" style="width: 90px;" />
            </q-tabs>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
// import { api } from 'boot/axios';
import filtersMixin from 'src/mixins/filtersMixin';
import SotHeader from 'components/ui/design/SotHeader';
import { queryBot } from 'boot/axios';
import DefaultButton from 'components/ui/common/DefaultButton';
import SotButton from 'components/ui/design/SotButton';

export default {
    name: 'PageSubscription',
    components: {
        SotButton,
        DefaultButton,
        SotHeader,
        BasePage,
    },
    mixins: [filtersMixin],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            tab: 'info',
            loading: false,
            error: undefined,
            subscription: undefined,
            prices: undefined,
            courses: undefined,
            subsBought: undefined,
        };
    },
    computed: {
        subscriptionId () {
            return this.params.subscription_id;
        },
        title () {
            const { title } = this.params;
            return title;
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        load () {
            this.loading = true;
            this.subscription = undefined;
            this.prices = undefined;
            this.products = undefined;
            this.subsBought = undefined;
            // const { user } = this.$store.state.pages;

            // Если эта подписка уже есть у пользователя - то вывести сообщение что подписка уже оформлена
            this.$db.users.getSubscriptionBought(this.subscriptionId).then((s) => {
                this.subsBought = s;
            });

            // Загрузить информацию о подписке
            this.$db.tasks.getSubscriptions(`id = ${this.subscriptionId}`).then((c) => {
                // eslint-disable-next-line prefer-destructuring
                this.subscription = c[0];
                // Загрузить информацию о тарифах подписки
                this.loadTariffs();
            });
        },
        loadTariffs () {
            queryBot(`select * from subscriptions_prices where subscription_id = ${this.subscription.id} order by duration_months, duration_days`).then((prices) => {
                this.prices = prices.data;
                // Загрузить информацию о продуктах
                this.loadProducts();
            });
        },
        loadProducts () {
            // Загрузить информацию о курсах
            this.loadCourses();
        },
        loadCourses () {
            const sql = ' SELECT '
                + ' courses.id as course_id, '
                + ' courses.title, '
                + ' courses.author, '
                + ' subscription_products.* '
                + ' FROM '
                + ' subscription_products '
                + ' INNER JOIN courses ON courses.id = product_id '
                + ' WHERE '
                + ` subscription_id = ${this.subscription.id} AND TYPE = 1`;
            queryBot(sql).then((r) => {
                this.courses = r.data;
                this.loading = false;
            });
        },
        courseClick (course) {
            this.$pages.push({
                to: 'course_page',
                course_id: course.course_id,
                label: course.title,
            });
        },
        buySubscription (tariff) {
            this.$pages.push({
                to: 'buy-subscription',
                subscription: this.subscription,
                tariff,
            });
        },
    },
};
</script>

<style scoped>

</style>
